import { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

export interface MVRDriverRow {
  id: string;
  name: string;
  licenceNumber: string;
}

export const createEmptyDriverRow = (): MVRDriverRow => ({
  id: uuidv4(),
  name: '',
  licenceNumber: '',
});

export const useDriverList = () => {
  const [drivers, setDrivers] = useState<MVRDriverRow[]>([
    createEmptyDriverRow(),
  ]);

  const addDriver = () => {
    setDrivers((prev) => [...prev, createEmptyDriverRow()]);
  };

  const removeDriver = (id: string) => {
    setDrivers((prev) =>
      prev.length > 1 ? prev.filter((driver) => driver.id !== id) : prev,
    );
  };

  const updateDriver = (
    id: string,
    field: keyof Omit<MVRDriverRow, 'id'>,
    value: string | number,
  ) => {
    setDrivers((prev) =>
      prev.map((driver) =>
        driver.id === id ? { ...driver, [field]: value } : driver,
      ),
    );
  };

  const resetDrivers = () => {
    setDrivers([createEmptyDriverRow()]);
  };

  return { drivers, addDriver, removeDriver, updateDriver, resetDrivers };
};
